import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AuthProvider from '../services/auth/AuthProvider/Index';
import { setUserData } from '../../redux/actions/userDataActions';

/**
 * Fetches the authenticated identity once and allows callers to seed local state.
 */
export const useIdentityPrefill = (onIdentity: (identity: any) => void) => {
  const dispatch = useDispatch();
  const [loadingIdentity, setLoadingIdentity] = useState(false);

  useEffect(() => {
    (async () => {
      setLoadingIdentity(true);
      const identity = await AuthProvider.getIdentity();
      if (identity) {
        dispatch(setUserData(identity));
        onIdentity(identity);
      }
      setLoadingIdentity(false);
    })();
  }, [dispatch, onIdentity]);

  return { loadingIdentity };
};

